import { useContext, useState, useCallback, useEffect } from 'react';
import { TableStateContext } from '../../model/table_state_context';
import { specificityList } from '../../model/specificity';
import { DebounceInput } from 'react-debounce-input';
import { useBreakpoints } from "@arise-biodiversity/components";
import WantedUnwantedFilter from './wanted_unwanted_filter';
import OccurrenceStatusFilter from './occurrence_status_filter';
import LocalityFilter from './locality_filter';
import ExportCsv from './export_csv';

export default function TargetlistGridHeader({ onGroupByChange }) {
    const {
        numberOfItems,
        tableSearchForString,
        setTableSearchForString,
        setOccurrenceStatusFilter,
        setLocalityFilter,
        setWantedFilter,
        countries,
        occStatus,
        setGroupBy,
        table
    } = useContext(TableStateContext);

    const searchPlaceholder = `Search ${numberOfItems} results`;
    const [showWantedUnwantedFilter, setShowWantedUnwantedFilter] = useState(true);
    const [allSpeciesData, setAllSpeciesData] = useState([]);
    const { isBelow } = useBreakpoints();
    const isMobile = isBelow("--breakpoint-md");

    const handleGroupByChange = (event) => {
        const groupByValue = event.target.value;
        setGroupBy(groupByValue);
        onGroupByChange(groupByValue);
        if (groupByValue === "species") {
            setShowWantedUnwantedFilter(true);
        } else {
            setShowWantedUnwantedFilter(false);
            setWantedFilter('all');
        }
    };

    const addOccurrenceStatusFilter = useCallback((occurrenceStatus) => {
        setOccurrenceStatusFilter(occurrenceStatus);
    }, [setOccurrenceStatusFilter]);

    const changeValue = useCallback((event) => {
        setTableSearchForString(event.target.value);
    }, [setTableSearchForString]);

    const addWantedUnwantedFilter = useCallback((value) => {
        setWantedFilter(value);
    }, [setWantedFilter]);

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                const res = await fetch('/api/Targetlist');
                const data = await res.json();
                setAllSpeciesData(data.items || []);
            } catch (err) {
                console.error('Failed to fetch full species data', err);
            }
        };

        fetchAllData();
    }, []);

    return (
        <div className="table-header-container">
            <div className="table-filters">
                {!isMobile && (
                    <label className="filter-label">
                        Filter by
                        <select defaultValue="species" onChange={handleGroupByChange} className="filter-dropdown">
                            {specificityList.map((item) => (
                                <option key={item} value={item}>{item}</option>
                            ))}
                        </select>
                    </label>

                )}
                <label className="filter-label">
                    Search
                    <DebounceInput
                        type="search"
                        placeholder={searchPlaceholder}
                        value={tableSearchForString || ""}
                        debounceTimeout={400}
                        onChange={changeValue}
                        className="text-input"
                        minLength={2}
                    />
                </label>
                {!isMobile && (
                    <>

                        {showWantedUnwantedFilter && (
                            <WantedUnwantedFilter onFilterChange={addWantedUnwantedFilter} />
                        )}

                        <OccurrenceStatusFilter statuses={occStatus} onFilterChange={addOccurrenceStatusFilter} />
                        <LocalityFilter
                            countries={countries}
                            onChange={(countryList) => setLocalityFilter(countryList)}
                        />
                    </>
                )}
            </div>

            <div className="tl-grid-header-right">
                <ExportCsv table={table} originalData={allSpeciesData} />
            </div>
        </div>
    );
}
